/* eslint-disable */
import { TextStyle } from './common.js';

export interface HeadingData {
  /** Heading level from 1-6. */
  level: number;
  /** Styling for the heading text. */
  textStyle?: TextStyle;
  /** Indentation level from 1-4. */
  indentation?: number;
}

const baseHeadingData: object = { level: 0 };

export const HeadingData = {
  fromJSON(object: any): HeadingData {
    const message = { ...baseHeadingData } as HeadingData;
    message.level =
      object.level !== undefined && object.level !== null
        ? Number(object.level)
        : 0;
    message.textStyle =
      object.textStyle !== undefined && object.textStyle !== null
        ? TextStyle.fromJSON(object.textStyle)
        : undefined;
    message.indentation =
      object.indentation !== undefined && object.indentation !== null
        ? Number(object.indentation)
        : undefined;
    return message;
  },

  toJSON(message: HeadingData): unknown {
    const obj: any = {};
    message.level !== undefined && (obj.level = Math.round(message.level));
    message.textStyle !== undefined &&
      (obj.textStyle = message.textStyle
        ? TextStyle.toJSON(message.textStyle)
        : undefined);
    message.indentation !== undefined &&
      (obj.indentation = message.indentation);
    return obj;
  },
};
